import styled from '@emotion/styled'
import { Icon } from 'rsuite'

export const BaseIcon = styled(Icon)``
